import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, mergeMap, of, timer, tap } from 'rxjs';
import { GetUser, SetUser, SetUserBalances, UserResetPass, authUser } from '../actions/user.actions';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from 'src/app/core/services/user/user.service';
import { GetUserInfo } from '../actions/userInfo.action';
import { LocalStorageService } from 'src/app/core/services/localStorage/local-storage.service';
import { Router } from '@angular/router';

@Injectable()
export class auhtUserEffect {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private user: UserService,
    private storage: LocalStorageService,
    private router: Router
  ) {}
  $checkUserAuth = createEffect(() => {
    return this.actions$.pipe(
      ofType(authUser['[authUser]AuthUser']),
      mergeMap((action) =>
        this.http
          .post<any>('/casino-api/auth-2/login', action, {
            headers: new HttpHeaders().set('X-UA-Fingerprint', action?.fingerprint),
          })
          .pipe(
            tap((res: any) => {
              if (res?.redirect_url) {
                window.open(res.redirect_url, '_self');
              }
            }),
            map((res: any) => {
              let data = res;
              if (data.success === true) {
                data = { ...data, result: { loggedIn: '1' } };
              }
              console.log(data);
              return authUser['[authUser]AuthUserSuccess']({ data });
            }),
            catchError((error: any) =>
              of(authUser['[authUser]AuthUserFailure']({ data: error?.error?.error?.response }))
            )
          )
      )
    );
  });
  //

  $userResetPassword = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserResetPass['[UserResetPass]UserResetPass']),
      mergeMap((action) =>
        this.http
          .post<any>('/userPassword', {
            email: action.data,
          })
          .pipe(
            map((res: any) =>
              UserResetPass['[UserResetPass]UserResetPassSuccess']({
                data: {
                  ...res,
                  action,
                },
              })
            ),
            catchError(() => of(UserResetPass['[UserResetPass]UserResetPassFailure']()))
          )
      )
    );
  });

  $getUserInfo = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetUser['[GetUser]GetUser']),
      mergeMap(() =>
        this.user.getUserInfo().pipe(
          map((res: any) => {
            return SetUser['[SetUser]SetUserInfoSuccess']({
              data: { ...res?.body, fundistDate: res?.headers.get('Date') },
            });
          }),
          catchError(() => of(SetUser['[SetUser]SetUserInfoFailure']()))
        )
      )
    );
  });

  $timerUserInfo = of(GetUserInfo['[GetUserInfo]GetUserInfo']());

  $getCurrenUserInfo = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetUserInfo['[GetUserInfo]GetUserInfo']),
      mergeMap(() =>
        this.user.getUserInfo().pipe(
          map((res: any) => {
            return SetUser['[SetUser]SetUserInfoSuccess']({
              data: { ...res?.body, fundistDate: res?.headers.get('Date') },
            });
          }),
          catchError(() => timer(5000).pipe(exhaustMap(() => this.$timerUserInfo)))
        )
      )
    );
  });

  $getUserProfile = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetUser['[GetUser]GetUser']),
      mergeMap(() =>
        this.user.getUserProfile().pipe(
          map((res: any) =>
            SetUser['[SetUser]SetUserProfileSuccess']({
              data: res,
            })
          ),
          catchError(() => of(SetUser['[SetUser]SetUserProfileFailure']()))
        )
      )
    );
  });

  $getUserInitialBalance = createEffect(() => {
    return this.actions$.pipe(
      // ofType(SetUser['[SetUser]SetUserProfileSuccess']), - Need to change after socket will fixed(Important)!
      ofType(SetUser['[SetUser]SetUserInfoSuccess']),
      exhaustMap(() =>
        this.user.getUserBalanceFromRequest().pipe(
          map((res: any) =>
            SetUserBalances['[SetUserBalances]SetUserBalanceSuccess']({
              data: res,
            })
          )
        )
      )
    );
  });
}
